// v2 campaign lane file — see app/v2/README.md. Owned by one build agent at a time;
// other agents and humans: do not edit. Routes here are HIDDEN (reachable only via
// /v2-screens and deep links) and every element must wrap in <RequireAuth>.
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from '@/shared/auth/RequireAuth';

// Rank #1 (v2_wins.html §r1, 20/20) — the campaign's exemplar page, built entirely on the
// shared kit at src/shared/v2/. The PB-faithful /manage/work-pool is untouched.
const WorkPool2Page = lazy(() => import('@/features/workpool/v2/WorkPool2Page'));

export const kitRoutes: ReactElement[] = [
  <Route
    key="/manage/work-pool2"
    path="/manage/work-pool2"
    element={
      <RequireAuth>
        <WorkPool2Page />
      </RequireAuth>
    }
  />,
];
